import Main from "niteroi/packages/customer-services/controllers/Main.controller";
import {Route$PatternMatchedEvent} from "sap/ui/core/routing/Route";
import {SearchField$LiveChangeEvent} from "sap/m/SearchField";
import {ListBase$SelectionChangeEvent} from "sap/m/ListBase";
import JSONModel from "sap/ui/model/json/JSONModel";
import {ILoadDataResponse} from "niteroi/packages/system/models/interfaces";

export default class Tickets extends Main {
    private readonly onPatternMatchedHandler = this.onPatternMatched.bind(this);
    public onInit(): void {
        super.onInit();
        const router = this.getRouter();
        const routeName = this.getCurrentRouteName(router);
        if (routeName) {
            const route = router.getRoute(routeName);

            route.detachPatternMatched(this.onPatternMatchedHandler);
            route.attachPatternMatched(this.onPatternMatchedHandler);
        }
    }

    protected onPatternMatched(event: Route$PatternMatchedEvent): void {
        const pattern = event.getSource().getPattern();
        if (pattern.includes("tickets/add")) {
            return;
        }

        const params = event.getParameters();
        const id = (params.arguments as { id: string }).id ?? "";
        this.getData(id);
    }

    protected getData(objectId: string = ""): void {
        this.getView().setBusyIndicatorDelay(0).setBusy(true);
        const modelName = `customerServicesTicket${objectId ? "Detail" : "Collection"}`;
        const model = this.getModel(modelName);
        const url = `/api/customer-services/tickets${objectId ? "/" + objectId : ""}`;
        const headers = this.getRequestHeaders();
        model.loadData(url, "", true, "GET", false, undefined, headers)
            .then()
            .catch((response: ILoadDataResponse) => {
                const responseText = JSON.parse(response.responseText);
                this.showToast(`${responseText.code} - ${responseText.error}`);
            })
            .finally(() => {
                this.getView().setBusy(false).setBusyIndicatorDelay(1000);
            });
    }

    public onPressCreateTickets(): void {
        this.navTo("customer-services/tickets/add", {}, true);
    }

    public onSearch(event: SearchField$LiveChangeEvent): void {
        this.onSearchList(event, "ticketList", ["title", "ticketNumber", "createdBy/fullName", "messages/0/messageFrom", "messages/0/messageTo", "city", "country"]);
    }

    public onSelectTicket(event: ListBase$SelectionChangeEvent): void {
        const listItem = event.getParameter("listItem");
        const context = listItem.getBindingContext("customerServicesTicketCollection");
        const model = context.getModel() as JSONModel;
        const ticket = model.getProperty(context.getPath());
        this.navTo("customer-services/tickets/edit", {id: ticket.ticketId}, true);
    }
}
